<template>
  <div>
    <el-card class="mb-3">
      <h5 v-if="baseInfo.scmName">{{ baseInfo.scmName }}</h5>
      <div class="d-flex justify-content-between">
        <div class="d-flex align-items-center">
          <div style="height: 29px;line-height: 29px;overflow: hidden;">
            <span style="font-size: 14px; color: #606266">
              No：{{ baseInfo.amzPurchaseNo || 'New' }}
            </span>
            <el-divider direction="vertical" />
            <el-tag
              size="mini"
              :type="
                !baseInfo.amzPurchaseStatus
                  ? ''
                  : baseInfo.amzPurchaseStatus === 'N'
                  ? 'primary'
                  : baseInfo.amzPurchaseStatus === 'Y'
                  ? 'success'
                  : baseInfo.amzPurchaseStatus === 'D'
                  ? 'danger'
                  : 'warning'
              "
            >
              {{ baseInfo.v_amzPurchaseStatus || 'New' }}
            </el-tag>
            <el-divider direction="vertical" />
            <el-tag
              v-if="baseInfo.v_skuSalesChannel"
              size="mini"
              :type="
                baseInfo.skuSalesChannel === 'F'
                  ? 'success'
                  : baseInfo.skuSalesChannel === 'V'
                  ? 'warning'
                  : ''
              "
            >
              {{ baseInfo.v_skuSalesChannel }}
            </el-tag>
            <el-divider direction="vertical" />
            <span style="font-size: 14px; color: #606266">
              Update：{{ baseInfo.modifyByName || '--' }} at
              {{ baseInfo.modifyDate || '--' }}
            </span>
          </div>
        </div>
        <div class="d-flex align-items-center" style="min-width: max-content;">
          <div class="mr-4" v-if="isAudit">
            <el-button type="success" size="small" @click="review()">
              {{ $l('btn_review') || '通过' }}
            </el-button>
            <el-button
              type="warning"
              size="small"
              @click="rejectedFormVisible = true"
            >
              {{ $l('btn_reject') || '驳回' }}
            </el-button>
          </div>
          <div class="switch-tabs_wrappers">
            <div class="switch-tabs">
              <div
                v-for="item in switchTabs"
                :key="item.value"
                class="switch-tabs_items"
                :class="{
                  active: item.value === activeName,
                  disabled: item.disabled,
                }"
                @click="!item.disabled ? (activeName = item.value) : () => {}"
              >
                <span>{{ item.label }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </el-card>

    <div>
      <el-card v-show="activeName == 'base'">
        <EditForm
          ref="editForm"
          :disabled="disabled"
          :amzPurchaseCode="amzPurchaseCode"
          @loaded="(data) => (baseInfo = data)"
        />
        <div class="d-flex justify-content-between mb-2 mt-2">
          <div>
            <span style="font-size: 14px; color: #606266">
              Create：{{ baseInfo.createByName || '--' }} at
              {{ baseInfo.createTime || '--' }}
            </span>
            <el-divider direction="vertical"></el-divider>
            <span style="font-size: 14px; color: #606266">
              Submit：{{ baseInfo.submitByName || '--' }} at
              {{ baseInfo.submitTime || '--' }}
            </span>
            <el-divider direction="vertical"></el-divider>
            <span style="font-size: 14px; color: #606266">
              Review：{{ baseInfo.reviewByName || '--' }} at
              {{ baseInfo.reviewTime || '--' }}
            </span>
          </div>
          <div>
            <el-button
              v-if="!disabled"
              type="primary"
              size="small"
              @click="$refs.editForm.save()"
            >
              {{ $l('INDEX.btn_save') || '保存' }}
            </el-button>
          </div>
        </div>
      </el-card>
      <el-card v-show="activeName == 'goods'">
        <SkuTable
          ref="skuTable"
          :disabled="disabled"
          :amzPurchaseCode="amzPurchaseCode"
          @reload="$refs.editForm.reload()"
        />
      </el-card>
      <el-card v-show="activeName == 'sample'">
        <SampleTable
          :disabled="disabled"
          :amzPurchaseCode="amzPurchaseCode"
          @reload="sampleReload()"
        />
      </el-card>
      <el-card v-show="activeName == 'batch'">
        <BatchTable
          :disabled="disabled"
          :amzPurchaseCode="amzPurchaseCode"
          @reload="$refs.editForm.reload()"
        />
      </el-card>
    </div>

    <RejectedForm
      :visible.sync="rejectedFormVisible"
      :amzPurchaseCode="amzPurchaseCode"
      @reload="goBackList"
    />
  </div>
</template>
<script>
import EditForm from '../components/edit-form'
import SkuTable from '../components/sku-table'
import SampleTable from '../components/sample-table'
import BatchTable from '../components/batch-table'
import RejectedForm from '../components/rejected-form'
import EditLoading from '@/mixins/edit-loading'
export default {
  name: 'ecom-awsBiz-ftyPurchase-detail',
  mixins: [EditLoading],
  components: { EditForm, SkuTable, SampleTable, BatchTable, RejectedForm },
  data() {
    return {
      baseInfo: {},
      activeName: 'base',
      rejectedFormVisible: false,
    }
  },
  computed: {
    params() {
      return this.$route.params
    },
    pageType() {
      return this.params.pageType
    },
    disabled() {
      return this.pageType === 'detail' || this.isAudit
    },
    isAudit() {
      return this.pageType === 'audit'
    },
    amzPurchaseCode() {
      return this.params.amzPurchaseCode
    },
    switchTabs() {
      return [
        { label: '基本信息', value: 'base' },
        { label: '订单产品', value: 'goods', disabled: !this.amzPurchaseCode },
        { label: '样品需求', value: 'sample', disabled: !this.amzPurchaseCode },
        { label: '出货批次', value: 'batch', disabled: !this.amzPurchaseCode },
      ]
    },
  },
  methods: {
    async review() {
      const confirm = await this.$confirm(
        this.$l('INDEX.tips_question_review') || '是否审核通过？',
        this.$l('INDEX.label_completeDesc') || '确认信息',
        {
          confirmButtonText: this.$l('INDEX.btn_confirm') || '确定',
          cancelButtonText: this.$l('INDEX.btn_cancel') || '取消',
          type: 'warning',
        }
      )
        .then(() => true)
        .catch(() => false)
      if (!confirm) return
      if (this.loadingOpen()) return

      const res = await this.$api
        .ecomAmzFtyPurchaseReviewApi({ amzPurchaseCode: this.amzPurchaseCode })
        .catch(() => null)
      this.loadingClose()
      if (!res) return

      const { status } = res
      if (status !== 200) {
        this.$message.error(this.$l('INDEX.tips_audit_failure') || '审核失败！')
        return
      }

      this.$message({
        message: this.$l('INDEX.tips_audit_success') || '审核成功！',
        type: 'success',
      })

      this.goBackList()
    },
    goBackList() {
      this.$eventBus.$emit('awsBiz-ftyPurchase-list-reload')
      this.$router.replace({ name: 'ecom-awsBiz-ftyPurchase' })
    },
    sampleReload() {
      this.$refs.editForm.reload()
      this.$refs.skuTable.getData()
    },
  },
}
</script>
<style lang="scss" scoped>
.switch-tabs {
  display: flex;
  .switch-tabs_items {
    padding: 4px 8px;
    color: #6c757d;
    font-size: 14px;
    margin-right: 20px;
    border-radius: 4px;
    cursor: pointer;
    min-width: max-content;
  }
  .switch-tabs_items:hover,
  .switch-tabs_items.active {
    color: #007bff;
    background-color: #f8f8f9;
  }
  .switch-tabs_items.disabled {
    cursor: no-drop;
  }
  .switch-tabs_items.disabled:hover {
    color: #8cc5ff;
  }
  .switch-tabs_items:last-child {
    margin-right: 0;
  }
}

::v-deep {
  .el-card__body {
    padding: 18px;
  }
}
</style>
